import React, { useState } from "react";
import { Container, Nav, Navbar, Button, NavDropdown } from "react-bootstrap";
import "./index.scss";
import logo from "../../../assets/images/FAV1.png";
import lang from "../../../assets/images/lang.png";
import { useTranslation } from "react-i18next";
import { FiX, FiMenu, FiChevronDown, FiChevronUp } from "react-icons/fi"; // 👇 ajout chevron
import { useNavigate, useLocation } from "react-router-dom";

export default function Header({ stylebg }) {
  const { i18n, t } = useTranslation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [openExpertise, setOpenExpertise] = useState(false);
  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang);
  };

  const handleMenuToggle = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleCloseMenu = () => {
    setIsMenuOpen(false);
  };

  const isActive = (path) => location.pathname === path;
  const scrollToSection = (path, id) => {
    navigate(path); // navigation vers la page cible
    handleCloseMenu();

    // Une fois sur la nouvelle page, attendre que le DOM se charge avant de scroller
    setTimeout(() => {
      const section = document.getElementById(id);
      if (section) {
        section.scrollIntoView({ behavior: "smooth" });
      }
    }, 500); // délai pour laisser le temps à la page de se charger
  };
  return (
    <div className="d-flex align-items-center justify-content-center header-wrapper">
      <header className={`header shadow-sm ${stylebg}`}>
        <Container
          fluid
          className="d-flex justify-content-between align-items-center pe-1">
          <Navbar expand="lg" className="p-0">
            <Navbar.Brand href="/" className="d-flex align-items-center">
              <img
                src={logo}
                alt="MSIT Conseil"
                className="header-logo me-2 ms-2"
              />
            </Navbar.Brand>

            {/* 🟢 Toggle Icon Menu */}
            <div
              className="menu-toggle-btn d-lg-none"
              onClick={handleMenuToggle}>
              {isMenuOpen ? (
                <FiX size={28} className="toggle-icon close-icon" />
              ) : (
                <FiMenu size={28} className="toggle-icon" color="#fff" />
              )}
            </div>

            <Navbar.Collapse id="main-navbar">
              <Nav className="ms-4 align-items-center">
                <Nav.Link
                  href="/"
                  className={`nav-item ${isActive("/") ? "active-link" : ""}`}>
                  {t("home")}
                </Nav.Link>

                <Nav.Link
                  href="/apropos"
                  className={`nav-item ${
                    isActive("/apropos") ? "active-link" : ""
                  }`}>
                  {t("A propos")}
                </Nav.Link>

                {/* 🔽 Dropdown Expertise avec icône */}
                <NavDropdown
                  title={
                    <span className="d-flex align-items-center gap-1 nav-item">
                      {t("Expertise")}
                      <FiChevronDown size={16} />
                    </span>
                  }
                  id="services-dropdown"
                  className="nav-item expertise-dropdown">
                      <NavDropdown.Item href="/bu-msit-advisory">
                    Conseil Stratégique
                  </NavDropdown.Item>
                  <NavDropdown.Item href="/bu-msit-conseil">
                    Conseil Technologique
                  </NavDropdown.Item>
                
                  <NavDropdown.Item href="/bu-msit-ai">
                    Intelligence Artificielle
                  </NavDropdown.Item>
                  <NavDropdown.Item href="/bu-msit-services">
                    Centre de services
                  </NavDropdown.Item>
                </NavDropdown>

                <Nav.Link
                  href="/rejoignez-msit"
                  className={`nav-item ${
                    isActive("/rejoignez-msit") ? "active-link" : ""
                  }`}>
                  {t("Rejoignez MSIT")}
                </Nav.Link>

                <Nav.Link
                  href="/blogs"
                  className={`nav-item ${
                    isActive("/blogs") ? "active-link" : ""
                  }`}>
                  Blog
                </Nav.Link>

                <Button
                  className="book-btn ms-3"
                  onClick={() => navigate("/contact")}>
                  {t("book_call")}
                </Button>
              </Nav>
            </Navbar.Collapse>
          </Navbar>
        </Container>
      </header>

      {/* 🌐 Lang switcher desktop */}
      <div className="d-none d-md-block">
        <div className="lang-switcher d-flex align-items-center gap-2">
          <img src={lang} alt="lang" />
          <span
            className={i18n.language === "en" ? "lang active" : "lang"}
            onClick={() => changeLanguage("en")}>
            EN
          </span>
          <span
            onClick={() => changeLanguage("fr")}
            className={i18n.language === "fr" ? "active lang" : "lang"}>
            FR
          </span>
        </div>
      </div>

      {/* 🌙 Menu Mobile */}
      {isMenuOpen && (
        <div className="d-md-none d-block">
          <div className="menu-overlay" onClick={handleCloseMenu}></div>

          <div className="mobile-menu">
            <div className="menu-items">
              <button onClick={() => scrollToSection("/apropos")}>
                {t("A propos")}
              </button>

              <button onClick={() => scrollToSection("/rejoignez-msit")}>
                {t("Rejoignez MSIT")}
              </button>

              {/* --- Sous-menu Expertise --- */}
              <div className="submenu">
                <button
                  className="d-flex align-items-center justify-content-center w-100"
                  onClick={() => setOpenExpertise(!openExpertise)}>
                  <span className="me-2">{t("Expertise")}</span>
                  {openExpertise ? (
                    <FiChevronUp size={18} />
                  ) : (
                    <FiChevronDown size={18} />
                  )}
                </button>

                {openExpertise && (
                  <div className="submenu-items">
                    <button
                      onClick={() => scrollToSection("/bu-msit-advisory")}
                      className="margin-top-menu">
                      Conseil Stratégique
                    </button>
                    <button
                      className="margin-top-menu"
                      onClick={() => scrollToSection("/bu-msit-conseil")}>
                      Conseil Technologique
                    </button>
                    
                   
                    <button
                      onClick={() => scrollToSection("/bu-msit-ai")}
                      className="margin-top-menu">
                      Intelligence Artificielle
                    </button>
                    <button
                      onClick={() => scrollToSection("/bu-msit-services")}
                      className="margin-top-menu">
                      Centre de services
                    </button>
                  </div>
                )}
              </div>

              <button onClick={() => scrollToSection("/blogs")}>Blogs</button>

              <button
                className="contact-btn"
                onClick={() => scrollToSection("/contact")}>
                {t("Contacter Nous")}
              </button>
            </div>

            <div className="d-flex align-items-center gap-2 lang-switcher">
              <img src={lang} alt="lang" />
              <span
                className={i18n.language === "en" ? "lang active" : "lang"}
                onClick={() => {
                  changeLanguage("en");
                  handleCloseMenu();
                }}>
                EN
              </span>
              <span
                onClick={() => {
                  changeLanguage("fr");
                  handleCloseMenu();
                }}
                className={i18n.language === "fr" ? "active lang" : "lang"}>
                FR
              </span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
